import axios from "axios";
import {getToken} from "@/utils/functions/TokenFunction";
import {getBaseUrl, getEncrypted,setDataInLocalStorage} from "@/utils/functions/helperFunctions";
import {AuthConfig, Config} from '@/utils/constants/configContants';
import { BASEDOMAIN } from "@/constants/allconstants";
import { errorToasterMessage } from "@/utils/functions/toaster";


export const login = async (data: any, callback: any, errorCallback: any) => {
    axios.post(`${BASEDOMAIN}/auth/login`, data, Config())
        .then((response: any) => {
            callback(response);
            setDataInLocalStorage("session_id", response.data.session_id);
            setDataInLocalStorage("email_address", getEncrypted(response.data.email_address));
            setDataInLocalStorage("userId", getEncrypted(response.data.user_id));
            setDataInLocalStorage("name", getEncrypted(response.data.full_name));
        })
        .catch((error: any) => {
            errorCallback(error);
        });
};

export const validateVerificationOTP = async (data: any, callback: any, errorCallback: any) => {
    await axios
        .post(`${BASEDOMAIN}/auth/verify-otp`, data, Config())
        .then((response: any) => {
            callback(response);
        })
        .catch((error: any) => {
            errorCallback(error);
            console.log(error?.response);
        });
};

export const resendVerificationOtp = async (data: any, callback: any, errorCallback: any) => {
    axios
        .post(`${BASEDOMAIN}/auth/resent-otp`, data, Config())
        .then((response: any) => {
            callback(response);
        })
        .catch((error: any) => {
            errorCallback(error.response.data);
            console.log(error);
        });
};

export const resetPassword = async (data: any, callback: any, errorCallback: any) => {
    axios
        .post(`${BASEDOMAIN}/user/reset-password`, data, Config())
        .then((response: any) => {
            callback(response);
        })
        .catch((error: any) => {
            errorCallback(error?.response?.data);
            console.log(error?.response);
        });
};

export const getRedirectToken = async () => {
    const token = await axios.post(
        `${BASEDOMAIN}/auth/portal`,
        { portal: "user" },
        AuthConfig()
    );
    return token.data;
};

export const ExpireToken = async (): Promise<{ redirect?: string } | undefined> => {
    try {
        const response = await axios.post(`${BASEDOMAIN}/auth/logout`, JSON.stringify({}), AuthConfig());
        return response.data;
    } catch {
        return undefined;
    }
};

export const userResetPassword = async (currentPass: string, newPass: string, callback: any, errCallback: any) => {
    return await axios
        .post(`${BASEDOMAIN}/user/change-password`, { current_password: currentPass, new_password: newPass }, AuthConfig())
        .then((res) => callback(res.data))
        .catch((err) => errCallback(err));
};

export const userSetPassword = async (newPass: string, callBack: any, errorCallback: any) => {
    return await axios.post(`${BASEDOMAIN}/user/set-password`, { password: newPass }, AuthConfig()).then(res => callBack(res.data)).catch((e) => {
        errorCallback(e.response)
    })
}

export const loginFromRedirectHash = async (hash: any, sso?: boolean) => {
    let url = `${BASEDOMAIN}/auth/portal/${hash}`
    if(sso) {
        url = `${url}?sso=${sso}`
    }
    const response = await axios.get(url, AuthConfig())
    return response.data
}

export const msal = async (organization: String, email: String, portal_type: String, callback: any) => {
    await axios.get(`${BASEDOMAIN}/auth/sso/azure?organization=${organization}&email=${email}&portal_type=${portal_type}&redirectUri=${getBaseUrl()}`).then(res => callback(res.data))
}

export const loginWithAzure = async (data: any, callback: any, errCallBack: any) => {
    const url = `${BASEDOMAIN}/auth/sso/azure/login?redirectUri=${window.location.origin}/login`

    navigator.geolocation.getCurrentPosition(async (position) => {
        var loc = JSON.stringify({
            "latitude": position.coords.latitude,
            "longitude": position.coords.longitude,
        })
        await axios.post(url,
            data,
            { ...Config(), headers: { ...Config().headers, 'Location': loc } })
            .then(res => callback(res))
            .catch(err => {
                errCallBack(err)
                errorToasterMessage(err?.response?.data?.message)
            })
    }, async err => {
        await axios.post(url, data, Config())
        .then(res => callback(res))
        .catch(err => {
            errCallBack(err)
            errorToasterMessage(err?.response?.data?.message)
        })
    })
}

export const verifyEmail = async (user: any, callback: any, errCallback: any) => {
    const post = async (headerConfig: any) => {
        try {
            const res = await axios.post(`${BASEDOMAIN}/auth/verify-email`, user, headerConfig);
            callback(res.data);
        } catch (err) {
            errCallback(err);
        }
    }

    navigator.geolocation.getCurrentPosition(async position => {
        const loc = {
            "latitude": position.coords.latitude,
            "longitude": position.coords.longitude,
        }
        const config = {
            headers: { 'Content-Type': 'application/json', 'Location': loc }
        };
        await post(config);
    }, async err => {
        const config = {
            headers: { 'Content-Type': 'application/json' }
        };
        await post(config);
    });
};

export const verifyCaptchaToken = async (token: string, callback: any, errCallback: any) => {
    await axios.post(`${BASEDOMAIN}/auth/verify-captcha`, { token })
        .then(res => callback(res.data))
        .catch(err => errCallback(err))
}